define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin",
	"./CarryOverSKUForm"
], function(array,declare,lang,csi,NewFrom,ActionControllerMixin,CarryOverSKUForm) {

	return declare([NewFrom, ActionControllerMixin], {
		_currentSKUNames: null,

		getFormData: function() {
			// summary: add hook into form data to determine if node is already selected
			if (this.m_formData) return this.m_formData;

			var	fd = this.inherited(arguments);
			fd.m_bOmitSelections = true;

		//  TODO
		//	DE23251  This commented out line makes checkboxes of all rows as greyed so NO row could be selected.
		//	The workaround is that all rows available for selection.
		//  The best solution will be that existing SKU's will have greyed checkboxes (so not available to select)
		//	fd.m_fAggregateSelected = lang.hitch(this, this._isPreselected);
			return fd;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			this._currentSKUNames = null;
			return bFinish ? null : this.inherited(arguments);
		},

        /**
         *  add special controller for SKU CarryOver form
         *  @param {Node} - node
         *  @param {boolean} - bCheckOnly
         */
        _getFormView: function(node, bCheckOnly) {
            var defView = this.inherited(arguments);
            if (defView) {
                defView.classController = CarryOverSKUForm;
            }

            return defView;
        },

		_isPreselected: function(/*csi.def.Context*/ctx, /*csi.action.FormData*/fd) {
			// summary: determine if SKU is preselected in selection table
			if (!this._currentSKUNames) {
				var	skus = this.m_cache.getNodes(this.getParent().RealizedProducts);
				this._currentSKUNames = {};
				array.forEach(skus, function(sku) {
					this._currentSKUNames[sku.$Name] = true;
				}, this);
			}

			return this._currentSKUNames[ctx.getNode().$Name];
		}
	});
});